import { render, staticRenderFns } from "./SpecificPressReleasePage.vue?vue&type=template&id=b1a665ce&scoped=true&"
import script from "./SpecificPressReleasePage.vue?vue&type=script&lang=js&"
export * from "./SpecificPressReleasePage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificPressReleasePage.vue?vue&type=style&index=0&id=b1a665ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a665ce",
  null
  
)

export default component.exports